import React from 'react';
import useBgPages from '../../../../hooks/use-bg-pages.hook';
import Input from '../../../../components/forms/input.component';
import SimpleTitle from '../../../../components/forms/simple-titles.component';
import { useFunctionsButtons } from '../../../../hooks/use-function-button.hook';

function locationButton({
  actionIndex,
  actionIndexCarrousel,
  index,
  indexCarrosuel,
  actionIndexSugestionsGeneral,
  cardIndex,
  type
}: {
  actionIndex?: any;
  actionIndexCarrousel?: any;
  index?: any;
  indexCarrosuel?: any;
  cardIndex?: any;
  actionIndexSugestionsGeneral?: any;
  type?: string;
}) {
  useBgPages();

  const {
    t,
    register,
    watch,
    errors,
    handleRemoveAction,
    handleKeyDown,
    handleRemoveActionCard,
    handleRemoveSuggestion
  } = useFunctionsButtons();

  return (
    <React.Fragment
      key={`action-call-${type === 'richCard' ? actionIndex : type === 'richCardCarrousel' ? actionIndexCarrousel : actionIndexSugestionsGeneral}`}
    >
      <div className="d-flex justify-content-between align-items-center mb-2">
        <SimpleTitle
          title="Ubicación"
          type="info fw-bolder"
          subtitle={`Botón ${type === 'richCard' ? actionIndex + 1 : type === 'richCardCarrousel' ? actionIndexCarrousel + 1 : actionIndexSugestionsGeneral + 1}`}
        />
        <button
          type="button"
          className="btn btn-link text-danger fw-bolder p-0"
          onClick={() => {
            if (type === 'richCard') {
              handleRemoveAction(index, actionIndex);
            } else if (type === 'richCardCarrousel') {
              handleRemoveActionCard(indexCarrosuel, cardIndex, actionIndexCarrousel);
            } else if (type === 'suggestionsGeneral') {
              handleRemoveSuggestion(actionIndexSugestionsGeneral);
            }
          }}
        >
          Eliminar
        </button>
      </div>
      {type === 'richCard' && (
        <div className="row">
          <div className="col-md-6">
            <Input
              label={t('templates.rcs.create.general-tag')}
              requiredIndicator="required"
              placeholder={t('templates.rcs.create.url-tag-placeholder')}
              currentLength={
                (watch(`elements.${index}.actions.${actionIndex}.gnlLabel`) as string)?.length || 0
              }
              errors={errors?.elements?.[index]?.actions?.[actionIndex]?.gnlLabel}
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(`elements.${index}.actions.${actionIndex}.gnlLabel`, {
                required: true,
                maxLength: {
                  value: 25,
                  message: 'Máximo 25 caracteres'
                }
              })}
              maxLength={25}
            />
          </div>
          <div className="col-md-6">
            <Input
              label="Etiqueta de ubicación"
              requiredIndicator="required"
              placeholder="Ingresa etiqueta de ubicación"
              currentLength={
                (watch(`elements.${index}.actions.${actionIndex}.label`) as string)?.length || 0
              }
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(`elements.${index}.actions.${actionIndex}.label`, {
                required: true,
                maxLength: {
                  value: 25,
                  message: 'Máximo 25 caracteres'
                }
              })}
              maxLength={25}
              errors={errors?.elements?.[index]?.actions?.[actionIndex]?.label}
            />
          </div>
          <div className="col-md-6">
            <Input
              type="number"
              label="Latitud"
              step="any"
              requiredIndicator="required"
              placeholder="-90.0 a 90.0"
              errors={errors?.elements?.[index]?.actions?.[actionIndex]?.latitude}
              {...register(`elements.${index}.actions.${actionIndex}.latitude`, {
                required: true,
                valueAsNumber: true,
                min: {
                  value: -90,
                  message: 'Latitud mínima: -90.0'
                },
                max: {
                  value: 90,
                  message: 'Latitud máxima: 90.0'
                }
              })}
            />
          </div>
          <div className="col-md-6">
            <Input
              type="number"
              label="Longitud"
              step="any"
              requiredIndicator="required"
              placeholder="-180.0 a 180.0"
              errors={errors?.elements?.[index]?.actions?.[actionIndex]?.longitude}
              {...register(`elements.${index}.actions.${actionIndex}.longitude`, {
                required: true,
                valueAsNumber: true,
                min: {
                  value: -180,
                  message: 'Longitud mínima: -180.0'
                },
                max: {
                  value: 180,
                  message: 'Longitud máxima: 180.0'
                }
              })}
            />
          </div>
        </div>
      )}
      {type === 'richCardCarrousel' && (
        <div className="row">
          <div className="col-md-6">
            <Input
              label={t('templates.rcs.create.general-tag')}
              requiredIndicator="required"
              placeholder={t('templates.rcs.create.url-tag-placeholder')}
              currentLength={
                (
                  watch(
                    `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.gnlLabel`
                  ) as string
                )?.length || 0
              }
              errors={
                errors?.elements?.[indexCarrosuel]?.cards?.[cardIndex]?.actions?.[
                  actionIndexCarrousel
                ]?.gnlLabel
              }
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(
                `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.gnlLabel`,
                {
                  required: true,
                  maxLength: {
                    value: 25,
                    message: 'Máximo 25 caracteres'
                  }
                }
              )}
              maxLength={25}
            />
          </div>
          <div className="col-md-6">
            <Input
              label="Etiqueta de ubicación"
              requiredIndicator="required"
              placeholder="Ingresa etiqueta de ubicación"
              currentLength={
                (
                  watch(
                    `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.label`
                  ) as string
                )?.length || 0
              }
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(
                `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.label`,
                {
                  required: true,
                  maxLength: {
                    value: 25,
                    message: 'Máximo 25 caracteres'
                  }
                }
              )}
              maxLength={25}
              errors={
                errors?.elements?.[indexCarrosuel]?.cards?.[cardIndex]?.actions?.[
                  actionIndexCarrousel
                ]?.label
              }
            />
          </div>
          <div className="col-md-6">
            <Input
              type="number"
              label="Latitud"
              step="any"
              requiredIndicator="required"
              placeholder="-90.0 a 90.0"
              errors={
                errors?.elements?.[indexCarrosuel]?.cards?.[cardIndex]?.actions?.[
                  actionIndexCarrousel
                ]?.latitude
              }
              {...register(
                `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.latitude`,
                {
                  required: true,
                  valueAsNumber: true,
                  min: {
                    value: -90,
                    message: 'Latitud mínima: -90.0'
                  },
                  max: {
                    value: 90,
                    message: 'Latitud máxima: 90.0'
                  }
                }
              )}
            />
          </div>
          <div className="col-md-6">
            <Input
              type="number"
              label="Longitud"
              step="any"
              requiredIndicator="required"
              placeholder="-180.0 a 180.0"
              errors={
                errors?.elements?.[indexCarrosuel]?.cards?.[cardIndex]?.actions?.[
                  actionIndexCarrousel
                ]?.longitude
              }
              {...register(
                `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.longitude`,
                {
                  required: true,
                  valueAsNumber: true,
                  min: {
                    value: -180,
                    message: 'Longitud mínima: -180.0'
                  },
                  max: {
                    value: 180,
                    message: 'Longitud máxima: 180.0'
                  }
                }
              )}
            />
          </div>
        </div>
      )}
      {type === 'suggestionsGeneral' && (
        <div className="row">
          <div className="col-md-6">
            <Input
              label={t('templates.rcs.create.general-tag')}
              requiredIndicator="required"
              placeholder={t('templates.rcs.create.url-tag-placeholder')}
              currentLength={
                (watch(`suggestions.${actionIndexSugestionsGeneral}.gnlLabel`) as string)?.length ||
                0
              }
              errors={errors?.suggestions?.[actionIndexSugestionsGeneral]?.gnlLabel}
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(`suggestions.${actionIndexSugestionsGeneral}.gnlLabel`, {
                required: true,
                maxLength: {
                  value: 25,
                  message: 'Máximo 25 caracteres'
                }
              })}
              maxLength={25}
            />
          </div>
          <div className="col-md-6">
            <Input
              label="Etiqueta de ubicación"
              requiredIndicator="required"
              placeholder="Ingresa etiqueta de ubicación"
              currentLength={
                (watch(`suggestions.${actionIndexSugestionsGeneral}.label`) as string)?.length || 0
              }
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(`suggestions.${actionIndexSugestionsGeneral}.label`, {
                required: true,
                maxLength: {
                  value: 25,
                  message: 'Máximo 25 caracteres'
                }
              })}
              maxLength={25}
              errors={errors?.suggestions?.[actionIndexSugestionsGeneral]?.label}
            />
          </div>
          <div className="col-md-6">
            <Input
              type="number"
              label="Latitud"
              step="any"
              requiredIndicator="required"
              placeholder="-90.0 a 90.0"
              errors={errors?.suggestions?.[actionIndexSugestionsGeneral]?.latitude}
              {...register(`suggestions.${actionIndexSugestionsGeneral}.latitude`, {
                required: true,
                valueAsNumber: true,
                min: {
                  value: -90,
                  message: 'Latitud mínima: -90.0'
                },
                max: {
                  value: 90,
                  message: 'Latitud máxima: 90.0'
                }
              })}
            />
          </div>
          <div className="col-md-6">
            <Input
              type="number"
              label="Longitud"
              step="any"
              requiredIndicator="required"
              placeholder="-180.0 a 180.0"
              errors={errors?.suggestions?.[actionIndexSugestionsGeneral]?.longitude}
              {...register(`suggestions.${actionIndexSugestionsGeneral}.longitude`, {
                required: true,
                valueAsNumber: true,
                min: {
                  value: -180,
                  message: 'Longitud mínima: -180.0'
                },
                max: {
                  value: 180,
                  message: 'Longitud máxima: 180.0'
                }
              })}
            />
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default locationButton;
